import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';

class TimelineGallery {
      rightArrow = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="28" viewBox="0 0 16 28"><path fill="#131414" d="M0 1.5285 13.056 12.9785 0 24.4295 1.34 25.9575 14.614 14.2615 14.614 11.6995 1.34 0.0005Z"/><path stroke="#131414" stroke-width="0.153" fill="none" d="M1.3402 0 0.0002 1.528 13.0562 12.978 0.0002 24.429 1.3402 25.957 14.6142 14.262 14.6142 11.699Z"/></svg>';
    leftArrow = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="28" viewBox="0 0 16 28"><path fill="#131414" transform="rotate(180 8 14)" d="M0 1.5285 13.056 12.9785 0 24.4295 1.34 25.9575 14.614 14.2615 14.614 11.6995 1.34 0.0005Z"/><path stroke="#131414" stroke-width="0.153" fill="none" transform="rotate(180 8 14)" d="M1.3402 0 0.0002 1.528 13.0562 12.978 0.0002 24.429 1.3402 25.957 14.6142 14.262 14.6142 11.699Z"/></svg>';
    closeBtn = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><g stroke="#000" stroke-width="1.5"><line x1="1" y1="1" x2="17" y2="17"/><line x1="17" y1="1" x2="1" y2="17"/></g></svg>';
    constructor($el) {
        this.$el = $el;

        this.$links = this.$el.find('.pswp-gallery-item');
        this.$prev = this.$el.find('.timeline-gallery__prev');
        this.$next = this.$el.find('.timeline-gallery__next');
        
        this.currentIndex = 0;
        this.total = this.$links.length;


        this.initLightbox();


        if (this.total > 1) {
            this.bindEvents();
        }
    }

    initLightbox() {
        this.lightbox = new PhotoSwipeLightbox({
                      arrowPrevSVG: this.leftArrow,
            arrowNextSVG: this.rightArrow,
            closeSVG:this.closeBtn,
            gallery: this.$el[0], 
            children: 'a.pswp-gallery-item',
            pswpModule: PhotoSwipe,
        });
        this.lightbox.init();
    }

    bindEvents() {

        this.$prev.on('click', (e) => {
            e.preventDefault();
            this.showImage(this.currentIndex - 1);
        });

        this.$next.on('click', (e) => {
            e.preventDefault();
            this.showImage(this.currentIndex + 1);
        });
    }

    showImage(index) {
        if (index < 0) index = this.total - 1;
        if (index >= this.total) index = 0;

        this.currentIndex = index;

        this.$links.addClass('is-hidden');
        this.$links.eq(this.currentIndex).removeClass('is-hidden');
    }
}

export default TimelineGallery;